var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStoreDefaultLtr = function SvgStoreDefaultLtr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.5 57.022a1.5 1.5 0 0 1 1.5 1.5v3.524a1.5 1.5 0 0 1-3 0v-3.524a1.5 1.5 0 0 1 1.5-1.5m-8.5 1.5a1.5 1.5 0 0 0-3 0v3.524a1.5 1.5 0 0 0 3 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1 20.25A2.25 2.25 0 0 1 3.25 18h93.5A2.25 2.25 0 0 1 99 20.25v.5A2.25 2.25 0 0 1 96.75 23H93v54.5h3.75A2.25 2.25 0 0 1 99 79.75v.5a2.25 2.25 0 0 1-2.25 2.25H3.25A2.25 2.25 0 0 1 1 80.25v-.5a2.25 2.25 0 0 1 2.25-2.25H7V23H3.25A2.25 2.25 0 0 1 1 20.75zM88.5 23h-77v4h77zm0 7h-77v47.499H27V42a3 3 0 0 1 3-3h41a3 3 0 0 1 3 3v35.499h14.5zM71 77.499V42H51.915q.084.236.085.5v34.999zM49.085 42H30v35.499h19V42.5q.001-.264.085-.5",
    clipRule: "evenodd"
  })));
};
export default SvgStoreDefaultLtr;